import { CSSProperties } from "react";

export default class DialogBaseViewStyle {

    container : CSSProperties = {
        minHeight : 480,
        width : 570,
        borderRadius : 15,
        backgroundColor : '#fff',
        overflow : 'hidden',
        display : "flex",
        flexDirection : 'column'
    }

    content : CSSProperties = {
        flex : 1,
        paddingTop : 20,
        paddingRight : 35,
        paddingLeft : 35,
        paddingBottom : 5,
        display : "flex",
        flexDirection : "column"
    }
}